import React from 'react'
import styled from '@emotion/styled'
import { FeatureFlagValue } from '@mobi/settings/index'
import { ExpandableToolboxSection } from '../Toolbox'
import { useAppSelector } from '@core/Store/hooks'

export const FeatureToggles = () => {
  const ldFeatures = useAppSelector(state => state.features.features)

  const sortedLdFeatures = React.useMemo(
    () =>
      Object.entries(ldFeatures).sort((a, b) =>
        a[0].toUpperCase().localeCompare(b[0].toUpperCase())
      ),
    [ldFeatures]
  )

  return (
    <ExpandableToolboxSection heading='LaunchDarkly Feature Flags'>
      <DataListStyled>
        {sortedLdFeatures.map(([key, value]) => (
          <React.Fragment key={key}>
            <dt>{key}:</dt>
            <dd>
              <span style={{ color: value ? 'green' : 'red' }}>{format(value)}</span>
            </dd>
          </React.Fragment>
        ))}
      </DataListStyled>
    </ExpandableToolboxSection>
  )
}

const format = (flagValue: FeatureFlagValue) => {
  if (typeof flagValue === 'undefined') {
    return 'Undefined'
  } else if (typeof flagValue === 'boolean') {
    return flagValue.toString()
  } else if (typeof flagValue === 'string') {
    return flagValue
  } else if (typeof flagValue === 'object') {
    return JSON.stringify(flagValue)
  } else if (typeof flagValue === 'number') {
    return flagValue.toString()
  } else {
    return 'Unrecognised type'
  }
}

const DataListStyled = styled.dl({
  overflowY: 'scroll',
  maxHeight: '20rem',
  fontSize: '14px',
})
